<div id="step3_addFilters" class="collapse" style="clear: both; display: none;">

	<!-- Title -->
	<h1 style="color:#f57300; font-size: 50px">
		<i class="fa fa-filter" aria-hidden="true"></i>
		STEP 3: ADD FILTER(S)
	</h1>
	
	<!-- Instructions -->
	<p style="color: #ffffff; font-size: 18px">
		Add filters so the rule is triggered at the right times, in the right locations, and by the right people.
	</p>
	
	<!-- ADD FILTER Button/Dropdown -->
	<div class="dropdown open">
		<button class="btn btn-default btn-lg dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="true">
		<i class="fa fa-filter" aria-hidden="true"></i>
		ADD FILTER
		<span class="caret"></span>
		</button>
		<ul class="dropdown-menu">
			<li (click)="onAddLocationFilter()" >
				<a data-toggle="collapse">
				<i class="fa fa-location-arrow" aria-hidden="true"></i>
				Location
				</a>
			</li>
			<li (click)="onAddFilter(mSourceTypes.TAG)">
				<a data-toggle="collapse">
				<i class="fa fa-tag" aria-hidden="true"></i>
				Tag
				</a>
			</li>
			<li (click)="onAddFilter(mSourceTypes.USER)">
				<a data-toggle="collapse">
				<i class="fa fa-user" aria-hidden="true"></i>
				User
				</a>
			</li>
			<li (click)="onAddFilter(mSourceTypes.OBJECT)">
				<a data-toggle="collapse">
				<i class="fa fa-circle-o" aria-hidden="true"></i>
				Object
				</a>
			</li>
			<li (click)="onAddTimeFilter()" >
				<a data-toggle="collapse">
				<i class="fa fa-calendar" aria-hidden="true"></i>
				DAYS(S) AND TIME(S)
				</a>
			</li>
		</ul>
	</div>
	
	<div>
	<br/>
	
	<!-- locations -->
	<div *ngIf="mRule != null && (mRule.locations != null || mRule.zones != null)" class="panel panel-drk-ornge">
		<app-location-filter-editor [rule]="this.mRule" [locations]="this.locations"></app-location-filter-editor>
	</div>
	
	<!-- day and time -->
	<div *ngIf="mRule.days != null && mRule.startTime != null" class="panel panel-drk-ornge">
		<app-time-filter-editor [rule]="this.mRule"></app-time-filter-editor>
	</div>
	
	<ng-container *ngIf="mRule.conditions != null" >
		<div style="margin-top: 10px;"></div>
		<div class="col-sm-9">
			<ng-container *ngFor="let condition of mRule.conditions;  let i = index;">
				<div *ngIf="condition.sourceType != mSourceTypes.EVENT" class="panel panel-drk-ornge">
						<app-entity-filter-editor
							[rule]="this.mRule"
							[ruleCondition]="condition" >
						</app-entity-filter-editor>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>